import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React from 'react';
import PropTypes from '../../node_modules/prop-types/index.js';
import brandingColors from '../colors/colors.js';
import { safeRest } from '../utils/functions.js';
import safeCustomStyle from '../utils/safeCustomStyle.js';
import { StyledP } from './styledComponents.js';
import { typography } from './typography.js';

var _excluded = ["children", "customStyle"];
var P = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    customStyle = _ref.customStyle,
    rest = _objectWithoutProperties(_ref, _excluded);
  var safeProps = safeRest(rest);
  var _safeCustomStyle = safeCustomStyle(customStyle),
    elementStyle = _safeCustomStyle.elementStyle;
  return /*#__PURE__*/React.createElement(StyledP, _extends({
    ref: ref,
    elementStyle: elementStyle
  }, safeProps), children);
});
process.env.NODE_ENV !== "production" ? P.propTypes = {
  children: PropTypes.node.isRequired,
  /** text color */
  color: PropTypes.string,
  disableFocusOutline: PropTypes.bool,
  /** text weight */
  weight: PropTypes.string,
  customStyle: PropTypes.shape({
    elementStyle: PropTypes.object
  })
} : void 0;
P.defaultProps = {
  color: brandingColors.light_1_dark_navy,
  disableFocusOutline: false,
  weight: typography.fontWeightNormal,
  customStyle: {
    elementStyle: {}
  }
};
process.env.NODE_ENV !== "production" ? P.displayName = 'P' : void 0;
var P$1 = P;

export { P$1 as default };
